import { render, staticRenderFns } from "./waiting-list-table.vue?vue&type=template&id=c3cae10c&scoped=true&"
import script from "./waiting-list-table.ts?vue&type=script&lang=ts&"
export * from "./waiting-list-table.ts?vue&type=script&lang=ts&"
import style0 from "./waiting-list-table.scss?vue&type=style&index=0&id=c3cae10c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3cae10c",
  null
  
)

export default component.exports